$shm_hitalama_entity_page $mol_page
	entity $giper_baza_entity
	head /
		<= Title $mol_string_button
			value? <=> title? \
		<= Tools
	tools /
		<= Cut $mol_button_minor
			title <= cut_title \Удалить
			click? <=> cut? null
	- tools /
